<template>
  <div class="page-render" :style="{ minHeight: isEditMode && 'inherit' }">
    <RootMatcher
      v-if="isAlive"
      ref="rootMatcher"
      :renderData="renderData"
      @openEditor="openEditor"
      @openChildEditor="openChildEditor"
      @changeChildrenOrder="changeChildrenOrder"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import RootMatcher from '../../matcher/rootMatcher.vue'
import RenderData from '../../RenderData'

export default {
  components: {
    RootMatcher
  },
  props: {
    renderData: {
      type: RenderData,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      theme: {
        bgColor: '',
        btnColor: ''
      },
      moduleRefs: {},
      isAlive: true
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.scrollModuleIntoView(this.$route.query.scrollin)
  },
  methods: {
    scrollModuleIntoView (id) {
      this.$nextTick(() => {
        if (!this.isAlive) {
          return
        }
        let el = null
        if (id) {
          const moduleRefs = this.moduleRefs[`renderData_${id}`]
          if (moduleRefs) {
            if (moduleRefs.$el) {
              el = moduleRefs.$el
            } else {
              el = moduleRefs
            }
          }
        }
        let top = 0
        if (el) {
          top = el.offsetTop - 62
        }
        const scrollOption = {
          top: top,
          behavior: 'smooth'
        }
        if (this.isEditMode) {
          document.querySelector('#pagePreviewer.page-previewer').scrollTo(scrollOption)
        } else {
          window.scrollTo(scrollOption)
        }
      })
    },
    openEditor (renderData) {
      if (!this.isEditMode) {
        return
      }
      this.$emit('openEditor', renderData.tag, renderData, true)
    },
    openChildEditor ({ renderData, editorName, childRenderData }) {
      if (!this.isEditMode) {
        return
      }
      this.$emit('openChildEditor', renderData, editorName, childRenderData)
    },
    changeChildrenOrder ({ newIndex, oldIndex, renderData }) {
      if (!this.isEditMode) {
        return
      }
      this.$emit('changeChildrenOrder', newIndex, oldIndex, renderData)
    },
    addModuleRef (refs) {
      _.merge(this.moduleRefs, refs)
    }
  },
  watch: {
    $route () {
      this.scrollModuleIntoView(this.$route.query.scrollin)
    },
    renderData () {
      this.isAlive = false
      this.$nextTick(() => {
        this.isAlive = true
        this.scrollModuleIntoView(this.$route.query.scrollin)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.site-common {
  .page-render {
    min-height: 100%;
    position: relative;

    * {
      box-sizing: border-box;
    }

    .microsite-root {
      position: relative;

      ::v-deep {
        .ql-editor {
          word-break: break-word;
          overflow: hidden;
        }
      }
    }
  }
}

.site-mobile {

}

.site-pc {
  &.edit-mode {
    .page-render {
      min-width: max-content;
      margin: 0 auto;
    }
  }
  .page-render {
    background: inherit;
  }
}
</style>
